import {Icon} from '@uwm/ui';
import type {SVGProps} from 'react';

const BellIcon = (props: SVGProps<SVGSVGElement>) => (
    <Icon width='16' height='16' viewBox='0 0 16 16' fill='none' {...props}>
        <g transform='translate(3 2.64)' stroke='currentColor'>
            <path d='M5.47897 1.99963C6.56463 1.99963 7.54931 2.44161 8.27275 3.15836C9.00135 3.88023 9.46542 4.88043 9.50405 5.99148L9.50635 9.6663H1.45127V6.15066C1.49086 4.96988 1.94916 3.93263 2.67407 3.18929C3.39809 2.44686 4.38746 1.99963 5.47897 1.99963Z' />
            <path d='M0.499629 9.66628H10.4996' strokeLinecap='round' />
            <path d='M6.78587 9.6664C6.78996 10.133 6.64321 10.4608 6.40595 10.6981C6.16869 10.9353 5.84092 11.0821 5.47888 11.0821C5.11683 11.0821 4.78906 10.9353 4.55181 10.6981C4.31455 10.4608 4.1678 10.133 4.1678 9.77099L6.78587 9.6664Z' />
            <path
                d='M4.4224 0.612822C4.77455 0.53736 5.12671 0.499629 5.47886 0.499629C5.83102 0.499629 6.18317 0.53736 6.53532 0.612822'
                strokeLinecap='round'
            />
        </g>
    </Icon>
);

export default BellIcon;
